import { memo } from 'react';
import { RankedTester, rankWith, scopeEndsWith, WithClassname } from '@jsonforms/core';
import { TranslateProps, withJsonFormsOneOfEnumProps, withTranslateProps } from '@jsonforms/react';
import MaterialOneOfEnumControl from './renderer';

export const MaterialEnumCell = (props: any & WithClassname & TranslateProps) => <MaterialOneOfEnumControl {...props} />;

/**
 * Default tester for enum controls.
 * @type {RankedTester}
 */
export const CopyConfigurationTester: RankedTester = rankWith(
  1000,
  scopeEndsWith('copy_configuration_from')
);

export default withJsonFormsOneOfEnumProps(withTranslateProps(memo(MaterialEnumCell)), false);
